

import React, { Component } from 'react';
import { Modal} from 'reactstrap';
import ScaleLoader from "react-spinners/ScaleLoader";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripePaymentComponent from './stripePaymentComponent'

const stateManager = require('../../../../../utils/state/stateManager');
const fatalErrorAction = require('../../../../../utils/state/actions/error/fatalErrorAction');
const paymentUtil = require('../../../../../utils/domain/paymentUtil');

class StripePaymentContainer extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.stripeInitialized = false;
        this.state.clientSecret = "";
        this.state.stripeLoader = null; 
    }

    render()
    {
        if (!this.state.stripeInitialized)
        {
            this.initializeStripe();

            return <Modal isOpen={true} centered >
                        <div className='AppBar'>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td style={{width:'99%'}}>
                                        <div style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'10px', paddingBottom:'5px'}}>
                                            Payment
                                        </div>

                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div style={{marginTop:'20px', marginBottom:'20px'}}>
                            <div style={{textAlign:'center'}}>
                                <ScaleLoader
                                            height={50}
                                            width={6}
                                            color={"#808080"}
                                            loading={true}/>
                            </div>
                            <div style={{textAlign:'center'}}>
                                Initializing Payment
                            </div>
                        </div>
                    </Modal>
        }

        const options = {
                            clientSecret: this.state.clientSecret,
                        };

                    
        let globalState = stateManager.getStore().getState();

        globalState.onCreditCardPaymentDismiss = this.props.onDismiss;

        return <Elements stripe={this.state.stripeLoader} options={options}>
                    <StripePaymentComponent />
                </Elements> 
    }

    async initializeStripe()
    {
        try
        {
            await this.getServerToken();

            const publishableKey = stateManager.getStore().getState().onlinePaymentConfiguration.publishableKey;

            this.state.stripeLoader = await loadStripe(publishableKey);
            
            this.state.stripeInitialized = true;
            this.setState({});
        }
        catch(error)
        {
            stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
        }
    }

    async getServerToken()
    {
        const amount = this.props.amount;
        const paymentIntent = await paymentUtil.createPaymentIntent(amount);

        if (!paymentIntent?.secret) 
        {
            throw new Error("Something went wrong! Please contact the restaurant for more information");
        }

        this.state.clientSecret = paymentIntent.secret;
    }
}

export default StripePaymentContainer;